import { Envs, TealiumEnvironment } from "../@types";

export const tealiumTagsSyncUrl =
  "https://tealium-tags.medicare.gov/medicare-www/{environment}/utag.sync.js";
export const tealiumTagsAsyncUrl =
  "//tealium-tags.medicare.gov/medicare-www/{environment}/utag.js";

export function getTealiumEnvironment(env: Envs): TealiumEnvironment {
  const tealiumEnvironmentMapping = {
    [Envs.local]: TealiumEnvironment.DEV,
    [Envs.dev]: TealiumEnvironment.DEV,
    [Envs.test]: TealiumEnvironment.DEV,
    [Envs.imp]: TealiumEnvironment.QA,
    [Envs.prod]: TealiumEnvironment.PROD,
  };

  return tealiumEnvironmentMapping[env];
}

export function getTealiumAsyncScriptUrl(env: TealiumEnvironment) {
  return tealiumTagsAsyncUrl.replace("{environment}", env);
}

export function getTealiumSyncScriptUrl(env: TealiumEnvironment) {
  return tealiumTagsSyncUrl.replace("{environment}", env);
}
